(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["try-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const wrappers = document.querySelectorAll('.ugc-wrapper');
  
  wrappers.forEach(function(wrapper) {
    const list = wrapper.querySelector('.ugc-list');
    if (!list) return;

    const left = wrapper.querySelector('.ugc-arrow--left');
    const right = wrapper.querySelector('.ugc-arrow--right');
    
    if (left) {
      left.addEventListener('click', function() {
        list.scrollBy({ left: -300, behavior: 'smooth' });
      });
    }
    if (right) {
      right.addEventListener('click', function() {
        list.scrollBy({ left: 300, behavior: 'smooth' });
      });
    }

    const medias = list.querySelectorAll('.ugc-media');
    const io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting || entry.target.dataset.loaded) return;
        
        const media = entry.target;
        const src = media.getAttribute('data-src');
        const type = media.getAttribute('data-type');
        
        if (type === 'mp4') {
          const video = document.createElement('video');
          video.setAttribute('playsinline', '');
          video.setAttribute('muted', '');
          video.setAttribute('loop', '');
          video.setAttribute('autoplay', 'autoplay');
          video.setAttribute('controls', '');
          video.muted = true;
          video.autoplay = true;
          video.src = src;
          media.appendChild(video);
        } else if (type === 'youtube') {
          const iframe = document.createElement('iframe');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
          iframe.src = 'https://www.youtube.com/embed/' + src + '?rel=0&modestbranding=1&mute=1&autoplay=1';
          media.appendChild(iframe);
        } else if (type === 'tiktok') {
          const iframe = document.createElement('iframe');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          iframe.src = src + 'embed/';
          media.appendChild(iframe);
        } else if (type === 'instagram') {
          const iframe = document.createElement('iframe');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
          iframe.style.width = '100%';
          iframe.style.height = '100%';
          let igUrl = src;
          igUrl = igUrl.split('?')[0];
          if (!igUrl.endsWith('/')) igUrl += '/';
          igUrl += 'embed/';
          iframe.src = igUrl;
          media.appendChild(iframe);
        }
        
        media.dataset.loaded = 'true';
        io.unobserve(media);
      });
    }, { root: list, threshold: 0.1 });

    medias.forEach(function(m) {
      io.observe(m);
    });

    list.querySelectorAll('.ugc-add').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        const variantId = btn.getAttribute('data-variant-id');
        const qtyInput = btn.closest('.ugc-item').querySelector('.ugc-qty');
        const qty = parseInt(qtyInput.value) || 1;

        console.log('Button clicked - Variant ID:', variantId, 'Qty:', qty);

        if (!variantId) {
          alert('Please select a product in the block settings');
          return;
        }

        btn.disabled = true;
        const originalText = btn.innerText;
        btn.innerText = 'Adding...';

        const cartPayload = {
          id: variantId,
          quantity: qty
        };

        console.log('Sending payload:', cartPayload);

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(cartPayload)
        })
        .then(function(response) {
          console.log('Response:', response.status);
          if (response.ok) {
            console.log('Item added successfully');
            btn.innerText = 'Added!';
            
            // Redirect to cart page after a short delay
            setTimeout(function() {
              window.location.href = '/cart';
            }, 1000);
          } else {
            throw new Error('Response not ok');
          }
        })
        .catch(function(error) {
          console.error('Cart error:', error);
          btn.innerText = 'Error';
          setTimeout(function() {
            btn.innerText = originalText;
            btn.disabled = false;
          }, 2000);
        });
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
